'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
require('./settings-9ee2f03f.js');
var isArray = _interopDefault(require('lodash/isArray'));
var panelStyles = require('./panel-styles-275a918b.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  width: 100%;\n  margin-bottom: 10px;\n  &:last-child {\n    margin-bottom: 0px;\n  }\n"], ["\n  width: 100%;\n  margin-bottom: 10px;\n  &:last-child {\n    margin-bottom: 0px;\n  }\n"]);

var TextList = styled__default.div(_templateObject);

var TextBox = styled__default.div(_templateObject2);

/**
 * The Text Warning Panel component
 * @param {String} text the text to show in the component
 * @param {String} margin the margin value of the component
 * @param {Boolean} error the type indicator of the component
 * @param {Boolean} warning the type indicator of the component
 */

var TextWarningPanel = function (_Component) {
  _babelHelpers.inherits(TextWarningPanel, _Component);

  function TextWarningPanel(props) {
    _babelHelpers.classCallCheck(this, TextWarningPanel);

    var _this = _babelHelpers.possibleConstructorReturn(this, (TextWarningPanel.__proto__ || Object.getPrototypeOf(TextWarningPanel)).call(this, props));

    _this.state = {};
    return _this;
  }

  _babelHelpers.createClass(TextWarningPanel, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          text = _props.text,
          children = _props.children,
          rest = _babelHelpers.objectWithoutProperties(_props, ["text", "children"]);

      return React__default.createElement(
        panelStyles.Panel,
        rest,
        isArray(text) ? React__default.createElement(
          TextList,
          null,
          text.map(function (t) {
            return React__default.createElement(
              TextBox,
              { key: t },
              t
            );
          })
        ) : text,
        children
      );
    }
  }]);
  return TextWarningPanel;
}(React.Component);

TextWarningPanel.propTypes = {
  /** text to display on panel */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /** indicator for panel type */
  error: PropTypes.bool,
  /** indicator for panel type */
  warning: PropTypes.bool,
  /** panel margin */
  margin: PropTypes.string,
  /** font size */
  fontSize: PropTypes.string,
  /** line height */
  lineHeight: PropTypes.string
};
TextWarningPanel.__docgenInfo = {
  "description": "The Text Warning Panel component\n@param {String} text the text to show in the component\n@param {String} margin the margin value of the component\n@param {Boolean} error the type indicator of the component\n@param {Boolean} warning the type indicator of the component",
  "methods": [],
  "displayName": "TextWarningPanel",
  "props": {
    "text": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "array"
        }]
      },
      "required": false,
      "description": "text to display on panel"
    },
    "error": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for panel type"
    },
    "warning": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for panel type"
    },
    "margin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "panel margin"
    },
    "fontSize": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "font size"
    },
    "lineHeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "line height"
    }
  }
};

module.exports = TextWarningPanel;
//# sourceMappingURL=alert.js.map
